<template>
  <label :class="`bundle bundle-${color}`">
    {{ $t(`mailer.sender.state.${value}`) }}
  </label>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: ''
      }
    },

    computed: {
      color: function () {
        /* eslint-disable no-unreachable, vue/script-indent */
        switch (this.value) {
          case 'new': {
            return 'blue';
          }
          case 'moderation': {
            return 'fresh';
          }
          case 'active': {
            return 'green';
          }
          case 'deactivated': {
            return 'gray';
          }
          case 'canceled': {
            return 'error';
          }
          case 'on_deactivation': {
            return 'yellow';
          }
          default: {
            return 'default';
          }
        }
        /* eslint-enable */
      }
    }
  };
</script>